export function normalizeMyCoursesPayload(payload) {
  const courses = Array.isArray(payload?.courses) ? payload.courses : [];

  return {
    summary: {
      totalCourses: Number(payload?.totalCourses ?? courses.length ?? 0),
      inProgressCourses: Number(payload?.inProgressCourses ?? 0),
      completedCourses: Number(payload?.completedCourses ?? 0),
    },
    courses: courses.map((course) => {
      const studentBookingId = course?.studentBookingId ?? course?.studentBookingid ?? course?.studentBookingId ?? null;
      return {
        id: studentBookingId ?? course?.courseId ?? 0,
        title: course?.courseName ?? "",
        code: course?.courseCode ?? "",
        description: course?.courseDescription ?? "",
        image: course?.bannerImage ?? "",
        date: course?.courseDate ?? "",
        location: course?.location ?? "",
        progress: Number(course?.studentProgressPercentage ?? course?.progressPercentage ?? 0),
        studentProgressPercentage: Number(course?.studentProgressPercentage ?? course?.progressPercentage ?? 0),
        studentCompletedStepCount: Number(course?.studentCompletedStepCount ?? course?.completedRequiredSteps ?? course?.completedStages ?? course?.completedStepCount ?? 0),
        studentTotalStepCount: Number(course?.studentTotalStepCount ?? course?.totalRequiredSteps ?? course?.totalStages ?? course?.totalStepCount ?? 0),
        instituteProgressPercentage: Number(course?.instituteProgressPercentage ?? 0),
        instituteCompletedStepCount: Number(course?.instituteCompletedStepCount ?? 0),
        instituteTotalStepCount: Number(course?.instituteTotalStepCount ?? 0),
        studentHasActionRequired: Boolean(course?.studentHasActionRequired),
        completedRequiredSteps: Number(course?.studentCompletedStepCount ?? course?.completedRequiredSteps ?? course?.completedStages ?? course?.completedStepCount ?? 0),
        totalRequiredSteps: Number(course?.studentTotalStepCount ?? course?.totalRequiredSteps ?? course?.totalStages ?? course?.totalStepCount ?? 0),
        completedStages: Number(course?.completedStages ?? course?.completedRequiredSteps ?? course?.completedStepCount ?? 0),
        totalStages: Number(course?.totalStages ?? course?.totalRequiredSteps ?? course?.totalStepCount ?? 0),
        currentStep: course?.currentStep ?? null,
        workFlowStatusNo: Number(course?.workFlowStatusNo ?? 1),
        workFlowStatusName: course?.workFlowStatusName ?? "Draft",
        status: course?.status ?? (course?.isCompleted ? "Completed" : "In Progress"),
        isCompleted: Boolean(course?.isCompleted),
        nextStep: course?.nextStep ?? "",
        buttonText: course?.buttonText ?? "Enter",
        certificateUrl: course?.certificateUrl ?? "",
        bookingNumber: course?.bookingNumber ?? "",
        enrolmentNumber: course?.enrolmentNumber ?? "",
        hasPendingAction: Boolean(course?.hasPendingAction),
        nextAction: course?.nextAction ?? null,
        courseId: course?.courseId ?? null,
        studentBookingId,
      };
    }),
  };
}
